import { render, staticRenderFns } from "./empty-page.vue?vue&type=template&id=29ea1272&"
import script from "./empty-page.ts?vue&type=script&lang=ts&"
export * from "./empty-page.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports